import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconLocationStyle0 = stylesCss;

const BiIconLocation$1 = /*@__PURE__*/ proxyCustomElement(class BiIconLocation extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '018cb4d3b785ddbdcb19eb0b31632f07258be0be', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '44cdda05979646d393ad63eae99f8e0d42f708f9', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'cf0decdfd8b6f0d8366ba9d0b526f9619bf3322c', d: 'M12.864 11.564a.999.999 0 1 0 0-1.997.999.999 0 0 0 0 1.997' }), h("path", { key: '3e942769bb0f8bc72a746d7870e5aaf16769622b', "fill-rule": 'evenodd', d: 'M12.864 5.075a5.493 5.493 0 0 0-5.491 5.49c0 .754.322 1.715.888 2.792.558 1.059 1.31 2.153 2.077 3.149a40.6 40.6 0 0 0 2.526 2.962 40.6 40.6 0 0 0 2.526-2.963c.765-.995 1.518-2.089 2.075-3.149.567-1.076.89-2.037.89-2.79 0-3.03-2.46-5.491-5.492-5.491Zm0 15.476-.531.53-.002-.001-.004-.004-.014-.015-.055-.056a39 39 0 0 1-.924-.983 42 42 0 0 1-2.185-2.602c-.795-1.032-1.602-2.201-2.215-3.365-.604-1.147-1.061-2.37-1.061-3.49a6.993 6.993 0 0 1 6.99-6.99 6.993 6.993 0 0 1 6.991 6.99c0 1.12-.457 2.343-1.061 3.49-.613 1.164-1.42 2.333-2.215 3.365a42.2 42.2 0 0 1-3.109 3.585l-.055.056-.014.015-.006.005zm0 0 .53.53-.53.53-.531-.53.53-.53Zm0-10.234a.249.249 0 1 0 0 .497.249.249 0 0 0 0-.497m-1.75.249a1.749 1.749 0 1 1 3.498 0 1.749 1.749 0 0 1-3.497 0Z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconLocationStyle0; }
}, [1, "bi-icon-location", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-location"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-location":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconLocation$1);
            }
            break;
    } });
}

const BiIconLocation = BiIconLocation$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconLocation, defineCustomElement };
